// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  HOST: 'https://portal.billtrim.fun/',
  API_BASE_URL: 'https://api.billtrim.fun/appnode/', // 'https://microservices.billtrim.com/appnode/',
  CUSTOMER_BASE_URL: 'https://api.billtrim.fun/customers/', //'https://microservices.billtrim.fun/customers/',
  SCRAPER_BASE_URL: 'https://api.billtrim.fun/billLinker/', //'https://microservices.billtrim.com/billLinker/',
  PDF_PARSER_BASE_URL: 'https://api.billtrim.fun/pdfparser/', //'https://microservices.billtrim.com/pdf-parser/',
  CELLPHONE_BASE_URL: 'https://api.billtrim.fun/cellphone/', //'https://microservices.billtrim.com/cellphone/',
  PORTAL_BASE_URL: 'https://api.billtrim.fun/portal/',
  // PORTAL_BASE_URL: 'http://localhost:3001/',
  BUNDLE_BASE_URL: 'https://api.billtrim.fun/bundle/', //'https://microservices.billtrim.com/bundle/',
  INSURANCE_BASE_URL: 'https://api.billtrim.fun/insurance/', //'https://microservices.billtrim.com/insurance/',
  ELECTRICITY_API_URL: 'https://electricity.billtrim.fun/', //'https://microservices.billtrim.com/electricity/',
  PUBNUB_PUBLISH_KEY: 'pub-c-123baba2-6312-4a2e-9ecb-752885d3cfb5',
  PUBNUB_SUBSCRIBE_KEY: 'sub-c-677326ac-88a0-11eb-88a7-4a59fc122af9',
  LOGGLY_TOKEN: '0bd70161-f2e6-4046-80d3-022a66776857',
  PUSHER_KEY: 'b74a626c71f7a2188a95',
  STRIPE_KEY: 'pk_test_7tDBLYrGn6BqpgNV7hbOXqeC',
  API_GATEWAY_TOKEN:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhMzZjMzA0OWIzNjI0OWEzYzlmODg5MWNiMTI3MjQzYyJ9.U8dOyd1978lmbWNk7gXHf7krDTjYKZanrVpayA0Lhug',
  AUTOPILOT_URL: 'https://api.billtrim.fun/autopilot/',
  AUTOPILOT_GATEWAY_TOKEN:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhMzZjMzA0OWIzNjI0OWEzYzlmODg5MWNiMTI3MjQzYyJ9.U8dOyd1978lmbWNk7gXHf7krDTjYKZanrVpayA0Lhug'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts